import type {Channel} from '../../lib/types';

export const EXPIRY_WARNING_MS=7*86_400_000;
const PLATFORM:Record<string,string>={linkedin:'LinkedIn',facebook:'Facebook',instagram:'Instagram'};

export type ExpiryWarning={connectionId:string;label:string;expiresAt:number;expired:boolean;daysLeft:number;canReconnect:boolean};

// Every active connection with a reported expiry inside the window stays listed,
// also after expiry, until a reconnect stores a new expiry. Unknown expiry is not guessed.
export function expiryWarnings(channels:Channel[],now:number,userId?:string):ExpiryWarning[] {
  const warnings:ExpiryWarning[]=[];
  for(const channel of channels) {
    if(channel.level!=='write')continue;
    for(const connection of channel.connections) {
      if(!['active','connected','expired'].includes(connection.state))continue;
      const expiresAt=Date.parse(connection.tokenExpiresAt??connection.expiresAt??'');
      if(!Number.isFinite(expiresAt)||expiresAt-now>EXPIRY_WARNING_MS)continue;
      warnings.push({
        connectionId:connection.id,
        label:`${PLATFORM[connection.platform]??connection.platform} · ${connection.displayName}`,
        expiresAt,expired:expiresAt<=now,
        daysLeft:Math.max(0,Math.ceil((expiresAt-now)/86_400_000)),
        canReconnect:!userId||channel.resource.ownerUserId===userId,
      });
    }
  }
  return warnings.sort((a,b)=>a.expiresAt-b.expiresAt);
}

export function expiryMessage(warning:ExpiryWarning):string {
  const date=new Date(warning.expiresAt).toLocaleDateString('da-DK',{day:'numeric',month:'long'});
  const when=warning.expired?`udløb ${date}. Planlagte opslag sendes ikke`
    :warning.daysLeft<=1?`udløber inden for et døgn (${date})`
    :`udløber om ${warning.daysLeft} dage (${date})`;
  const action=warning.canReconnect?'Genforbind under Indstillinger.':'Kanalens ejer skal genforbinde den.';
  return `${warning.label} ${when}. ${action}`;
}
